import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../services/api'
import SortableTh, { sortRows } from '../components/SortableTh'
import Paginacao, { usePaginacao } from '../components/Paginacao'
import { formatMoney } from './Apolices'
import { useNavegacaoLista } from '../hooks/useNavegacaoLista'
import SenhaMasterModal from '../components/SenhaMasterModal'
import IconExcluir from '../components/icons/IconExcluir'
import IconVisualizar from '../components/icons/IconVisualizar'
import IconEditar from '../components/icons/IconEditar'
import { avisar, confirmar } from '../components/Avisos'
import SelecaoMultipla from '../components/SelecaoMultipla'

const statusOptions = [
  { value: 'aberta',                label: 'Aberta',                cls: 'badge-blue' },
  { value: 'agendada',              label: 'Agendada',              cls: 'badge-amber' },
  { value: 'em_andamento',          label: 'Em Andamento',          cls: 'badge-amber' },
  { value: 'finalizada',            label: 'Finalizada',            cls: 'badge-green' },
  { value: 'aguardando_reembolso',  label: 'Aguardando Reembolso',  cls: 'badge-amber' },
]
const statusInfo = (v) => statusOptions.find(s => s.value === v) || { label: v || '—', cls: 'badge-gray' }

const tiposAnexoAssistencia = ['Nota Fiscal', 'Comprovante de Pagamento', 'Fotos', 'Orçamento', 'Laudo/Relatório', 'Outros']

// DATE do Postgres vira JSON como "AAAA-MM-DDT00:00:00.000Z" (meia-noite UTC) — reconstruir com o
// "Z" faz o toLocaleDateString num fuso atras de UTC (Brasil) voltar 1 dia. Por isso sempre
// descarta a hora/fuso vindos do backend e ancora de novo em meia-noite LOCAL.
const fmtData = (d) => d ? new Date(d.split('T')[0] + 'T00:00:00').toLocaleDateString('pt-BR') : '—'

const sec = (t) => (
  <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.06em', margin: '0 0 12px', paddingBottom: 6, borderBottom: '2px solid var(--primary-light)' }}>{t}</div>
)
const subLabelSublinhado = (t) => (
  <div style={{ fontSize: 12, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '16px 0 8px', textDecoration: 'underline', textUnderlineOffset: 3 }}>{t}</div>
)

const initForm = {
  numero_assistencia: '', apolice_id: '', cliente_id: '', apolice_item_id: '',
  data_abertura: '', tipo_assistencia: '', detalhe: '', descricao: '',
  valor_franquia: '', valor_outros: '',
  status: 'aberta', observacoes: '',
}

// ===== Histórico de Atendimento (mesmo padrão do Sinistro, sem opção de terceiro — Assistência só
// tem o segurado) =====
function RegistrarAtendimentoAssistencia({ assistenciaId, onRegistrado }) {
  const [texto, setTexto] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [salvo, setSalvo] = useState(false)

  const registrar = async () => {
    if (!texto.trim()) return
    setEnviando(true)
    try {
      await api.post(`/assistencias/${assistenciaId}/historico`, { texto })
      setTexto('')
      setSalvo(true)
      setTimeout(() => setSalvo(false), 2500)
      onRegistrado?.()
    } catch (err) {
      avisar('Erro ao salvar: ' + (err.response?.data?.erro || err.message))
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="form-group">
      <label className="form-label">Registrar atendimento</label>
      <textarea
        className="form-input" rows={5} style={{ resize: 'vertical' }}
        placeholder="Contato com o cliente, seguradora, prestador do serviço..."
        value={texto} onChange={e => setTexto(e.target.value)}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10, marginTop: 6 }}>
        <button type="button" className="btn btn-primary btn-sm" onClick={registrar} disabled={enviando || !texto.trim()}>
          {enviando ? 'Registrando...' : 'Registrar'}
        </button>
        {salvo && <span style={{ fontSize: 12, color: '#3B6D11' }}>✓ Atendimento registrado</span>}
      </div>
    </div>
  )
}

function HistoricoAssistencia({ assistenciaId }) {
  const [itens, setItens] = useState([])
  const [carregando, setCarregando] = useState(true)

  const carregar = () => {
    setCarregando(true)
    api.get(`/assistencias/${assistenciaId}/historico`)
      .then(r => setItens(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItens([]))
      .finally(() => setCarregando(false))
  }
  useEffect(() => { carregar() }, [assistenciaId])

  const remover = async (id) => {
    if (!(await confirmar('Remover esta anotação?'))) return
    await api.delete(`/assistencias/historico/${id}`)
    carregar()
  }

  const fmtDataHora = (iso) => new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
  })

  return (
    <div>
      <RegistrarAtendimentoAssistencia assistenciaId={assistenciaId} onRegistrado={carregar} />
      {carregando ? (
        <div style={{ textAlign: 'center', color: '#aaa', padding: 20, fontSize: 13 }}>Carregando...</div>
      ) : itens.length === 0 ? (
        <div style={{ padding: 20, textAlign: 'center', color: '#aaa', background: '#f8f9fa', borderRadius: 8, fontSize: 13 }}>
          Nenhum atendimento registrado ainda.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxHeight: 320, overflowY: 'auto', paddingRight: 2 }}>
          {itens.map(h => (
            <div key={h.id} style={{ position: 'relative', background: '#f8f9fa', borderRadius: 8, borderLeft: '3px solid var(--primary)', padding: '10px 28px 10px 14px' }}>
              <button type="button" onClick={() => remover(h.id)} title="Remover" style={{
                position: 'absolute', top: 8, right: 8,
                background: 'none', border: 'none', color: '#bbb', cursor: 'pointer', fontSize: 14, lineHeight: 1
              }}>×</button>
              <p style={{ fontSize: 10, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 3px' }}>
                {fmtDataHora(h.created_at)}
              </p>
              <p style={{ fontSize: 13, fontWeight: 700, color: '#2F2F2E', margin: '0 0 2px', whiteSpace: 'pre-wrap' }}>{h.texto}</p>
              <p style={{ fontSize: 11, color: '#888', margin: 0 }}>{h.usuario_nome || ''}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// ===== Anexos (mesmo padrão de sinistro_anexos/apolice_anexos) =====
function AnexosAssistencia({ id }) {
  const [anexos, setAnexos] = useState([])
  const [novoAnexo, setNovoAnexo] = useState(null)
  const [enviando, setEnviando] = useState(false)

  const carregar = () => {
    api.get(`/assistencias/${id}/anexos`)
      .then(r => setAnexos(Array.isArray(r.data) ? r.data : []))
      .catch(() => setAnexos([]))
  }
  useEffect(() => { carregar() }, [id])

  const selecionarArquivo = (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    if (file.size > 5 * 1024 * 1024) { avisar('Arquivo muito grande. Máximo 5MB.'); return }
    setNovoAnexo(n => ({ ...n, arquivo: file }))
  }

  const confirmarAnexo = async () => {
    if (!novoAnexo?.arquivo) { avisar('Selecione um arquivo.'); return }
    if (!novoAnexo?.tipo) { avisar('Selecione o tipo do documento.'); return }
    setEnviando(true)
    try {
      const dados = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = ev => resolve(ev.target.result)
        reader.onerror = reject
        reader.readAsDataURL(novoAnexo.arquivo)
      })
      await api.post(`/assistencias/${id}/anexos`, {
        tipo: novoAnexo.tipo, nome: novoAnexo.arquivo.name, tamanho: novoAnexo.arquivo.size, dados
      })
      carregar()
      setNovoAnexo(null)
    } catch (err) {
      avisar('Erro ao enviar anexo: ' + (err.response?.data?.erro || err.message))
    } finally {
      setEnviando(false)
    }
  }

  const remover = async (anexoId) => {
    if (!(await confirmar('Remover este anexo?'))) return
    await api.delete(`/assistencias/anexos/${anexoId}`)
    carregar()
  }

  const visualizar = async (a) => {
    try {
      const { data } = await api.get(`/assistencias/anexos/${a.id}/dados`)
      const parts = data.dados.split(',')
      const mimeType = parts[0].split(':')[1].split(';')[0]
      const byteStr = atob(parts[1])
      const ab = new ArrayBuffer(byteStr.length)
      const ia = new Uint8Array(ab)
      for (let x = 0; x < byteStr.length; x++) ia[x] = byteStr.charCodeAt(x)
      const blob = new Blob([ab], { type: mimeType })
      window.open(URL.createObjectURL(blob), '_blank')
    } catch (err) {
      avisar('Erro ao abrir anexo: ' + (err.response?.data?.erro || err.message))
    }
  }

  const formatSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B'
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
  }
  const getIcon = (nome) => {
    const ext = (nome || '').split('.').pop().toLowerCase()
    if (ext === 'pdf') return '📕'
    if (['jpg', 'jpeg', 'png'].includes(ext)) return '🖼️'
    return '📄'
  }

  return (
    <>
      {anexos.length > 0 && (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 16 }}>
          <tbody>
            {anexos.map(a => (
              <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '8px 10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: 11, background: 'var(--primary-light)', color: 'var(--primary)', padding: '3px 8px', borderRadius: 6, fontWeight: 500, flexShrink: 0 }}>{a.tipo}</span>
                    <span style={{ fontSize: 18 }}>{getIcon(a.nome)}</span>
                    <button type="button" onClick={() => visualizar(a)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontSize: 12, color: 'var(--primary)', textDecoration: 'underline', fontFamily: 'inherit', wordBreak: 'break-all', textAlign: 'left' }}>{a.nome}</button>
                  </div>
                </td>
                <td style={{ padding: '8px 10px', fontSize: 12, color: '#888' }}>{formatSize(a.tamanho || 0)}</td>
                <td style={{ padding: '8px 10px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => visualizar(a)}>Visualizar</button>
                    <button type="button" className="btn btn-danger btn-sm" onClick={() => remover(a.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {anexos.length === 0 && !novoAnexo && (
        <div style={{ padding: 32, textAlign: 'center', color: '#aaa', background: '#f8f9fa', borderRadius: 8, marginBottom: 16 }}>
          Nenhum anexo adicionado ainda.
        </div>
      )}
      {novoAnexo && (
        <div style={{ background: '#f8f9fa', border: '1px solid #e0e0e0', borderRadius: 10, padding: 16, marginBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 12 }}>Novo Anexo</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 220px', gap: 12, marginBottom: 12 }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Arquivo</label>
              <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={selecionarArquivo} style={{ fontSize: 13, padding: '6px 0', display: 'block', width: '100%' }} />
              {novoAnexo.arquivo && <span style={{ fontSize: 11, color: '#3B6D11', marginTop: 4, display: 'block' }}>✓ {novoAnexo.arquivo.name} ({formatSize(novoAnexo.arquivo.size)})</span>}
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Tipo do Documento</label>
              <select className="form-select" value={novoAnexo.tipo} onChange={e => setNovoAnexo(n => ({ ...n, tipo: e.target.value }))}>
                <option value="">Selecione...</option>
                {tiposAnexoAssistencia.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" className="btn btn-primary btn-sm" onClick={confirmarAnexo} disabled={enviando}>{enviando ? 'Enviando...' : '✓ Salvar anexo'}</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={() => setNovoAnexo(null)}>Cancelar</button>
          </div>
        </div>
      )}
      {!novoAnexo && <button type="button" className="btn btn-secondary" onClick={() => setNovoAnexo({ arquivo: null, tipo: '' })}>+ Adicionar novo anexo</button>}
      <div style={{ marginTop: 12, fontSize: 11, color: '#aaa' }}>Formatos aceitos: PDF, JPG, PNG. Tamanho máximo: 5MB por arquivo.</div>
    </>
  )
}

function CampoResumo({ label, valor }) {
  return (
    <div>
      <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>{label}</div>
      <div style={{ color: '#333' }}>{valor || '—'}</div>
    </div>
  )
}

// ===== Formulário/visualização da Assistência =====
function AssistenciaModal({ assistenciaId: assistenciaIdInicial, apoliceInicial, onClose, onSaved, voltarLabel = 'Assistências', onVoltar = null }) {
  const [assistenciaId, setAssistenciaId] = useState(assistenciaIdInicial || null)
  const [form, setForm] = useState(initForm)
  const [apoliceBusca, setApoliceBusca] = useState('')
  const [apoliceSelecionada, setApoliceSelecionada] = useState(null)
  const [mostrarSugestoesApolice, setMostrarSugestoesApolice] = useState(false)
  const [apolicesTodas, setApolicesTodas] = useState([])
  const [itensApolice, setItensApolice] = useState([])
  const [coberturasAcessoriasSeguradora, setCoberturasAcessoriasSeguradora] = useState([])
  const [clienteSelecionado, setClienteSelecionado] = useState(null)
  const [anexoApolicePdf, setAnexoApolicePdf] = useState(null)
  const [salvando, setSalvando] = useState(false)
  const [carregando, setCarregando] = useState(!!assistenciaIdInicial)
  // Assistencia ja salva abre direto na visualizacao (resumo); so entra no formulario de edicao
  // completo ao criar uma nova ou ao clicar em "Editar" (mesmo padrao de Sinistros.jsx).
  const [modoEdicao, setModoEdicao] = useState(!assistenciaIdInicial)
  const [pedirSenhaMasterExcluir, setPedirSenhaMasterExcluir] = useState(false)
  const apoliceTravada = !!apoliceInicial

  useEffect(() => {
    api.get('/apolices').then(r => setApolicesTodas(Array.isArray(r.data) ? r.data : [])).catch(() => setApolicesTodas([]))
  }, [])

  useEffect(() => {
    if (!form.cliente_id) { setClienteSelecionado(null); return }
    api.get(`/clientes/${form.cliente_id}`).then(r => setClienteSelecionado(r.data)).catch(() => setClienteSelecionado(null))
  }, [form.cliente_id])

  useEffect(() => {
    if (!form.apolice_id) { setAnexoApolicePdf(null); return }
    api.get(`/apolices/${form.apolice_id}/anexos`).then(r => {
      const lista = Array.isArray(r.data) ? r.data : []
      setAnexoApolicePdf(lista.find(a => a.tipo === 'Apólice') || lista.find(a => a.tipo === 'Endosso') || lista[0] || null)
    }).catch(() => setAnexoApolicePdf(null))
  }, [form.apolice_id])

  const abrirPdfApolice = async () => {
    if (!anexoApolicePdf) return
    try {
      const { data } = await api.get(`/apolices/anexos/${anexoApolicePdf.id}/dados`)
      const parts = data.dados.split(',')
      const mimeType = parts[0].split(':')[1].split(';')[0]
      const byteStr = atob(parts[1])
      const ab = new ArrayBuffer(byteStr.length)
      const ia = new Uint8Array(ab)
      for (let x = 0; x < byteStr.length; x++) ia[x] = byteStr.charCodeAt(x)
      const blob = new Blob([ab], { type: mimeType })
      window.open(URL.createObjectURL(blob), '_blank')
    } catch (err) {
      avisar('Erro ao abrir PDF: ' + (err.response?.data?.erro || err.message))
    }
  }

  useEffect(() => {
    if (apoliceInicial) {
      setApoliceSelecionada(apoliceInicial)
      setApoliceBusca(`${apoliceInicial.cliente_nome} — ${apoliceInicial.numero_apolice || apoliceInicial.emissao_numero_apolice || 'sem número'}`)
      setForm(f => ({ ...f, apolice_id: apoliceInicial.id, cliente_id: apoliceInicial.cliente_id }))
    }
  }, [apoliceInicial])

  const carregarAssistencia = async (id) => {
    const { data: s } = await api.get(`/assistencias/${id}`)
    setForm({
      numero_assistencia: s.numero_assistencia || '',
      apolice_id: s.apolice_id, cliente_id: s.cliente_id, apolice_item_id: s.apolice_item_id || '',
      data_abertura: s.data_abertura?.split('T')[0] || '',
      tipo_assistencia: s.tipo_assistencia || '', detalhe: s.detalhe || '', descricao: s.descricao || '',
      valor_franquia: s.valor_franquia != null ? formatMoney(s.valor_franquia) : '',
      valor_outros: s.valor_outros != null ? formatMoney(s.valor_outros) : '',
      status: s.status || 'aberta', observacoes: s.observacoes || '',
    })
    setApoliceSelecionada({ id: s.apolice_id, cliente_id: s.cliente_id, cliente_nome: s.cliente_nome, numero_apolice: s.numero_apolice, emissao_numero_apolice: s.emissao_numero_apolice, seguradora: s.seguradora, ramo: s.ramo })
    setApoliceBusca(`${s.cliente_nome} — ${s.numero_apolice || s.emissao_numero_apolice || 'sem número'}`)
  }

  useEffect(() => {
    if (!assistenciaIdInicial) return
    setCarregando(true)
    carregarAssistencia(assistenciaIdInicial).catch(() => {}).finally(() => setCarregando(false))
  }, [assistenciaIdInicial])

  // Cancelar a edicao de uma assistencia ja existente descarta as alteracoes locais recarregando
  // os dados originais do servidor antes de voltar pra visualizacao (resumo).
  const cancelarEdicao = async () => {
    if (!assistenciaId) { onClose(); return }
    setCarregando(true)
    try { await carregarAssistencia(assistenciaId) } catch { /* mantem os dados atuais se falhar */ }
    setCarregando(false)
    setModoEdicao(false)
  }

  useEffect(() => {
    if (!form.apolice_id) { setItensApolice([]); return }
    api.get(`/itens/apolice/${form.apolice_id}`).then(r => setItensApolice(Array.isArray(r.data) ? r.data : [])).catch(() => setItensApolice([]))
  }, [form.apolice_id])

  // Tipo de Assistência vem das coberturas acessórias marcadas em Cadastro > Coberturas (campo
  // "assistencia") pra essa seguradora/ramo — cada seguradora nomeia/oferece assistências
  // diferentes, entao a lista nao e fixa no codigo. So busca aqui o cadastro geral (o que a
  // seguradora OFERECE); o cruzamento com o que foi CONTRATADO no item vem abaixo.
  useEffect(() => {
    if (!apoliceSelecionada?.seguradora || !apoliceSelecionada?.ramo) { setCoberturasAcessoriasSeguradora([]); return }
    api.get(`/coberturas/${encodeURIComponent(apoliceSelecionada.seguradora)}/${encodeURIComponent(apoliceSelecionada.ramo)}`)
      .then(r => {
        const lista = Array.isArray(r.data) ? r.data : []
        setCoberturasAcessoriasSeguradora(lista.filter(c => c.assistencia))
      })
      .catch(() => setCoberturasAcessoriasSeguradora([]))
  }, [apoliceSelecionada?.seguradora, apoliceSelecionada?.ramo])

  const itemSelecionadoObj = itensApolice.find(i => String(i.id) === String(form.apolice_item_id)) || null

  // Das coberturas acessórias que a seguradora oferece pra esse ramo, só entram na lista as que
  // de fato foram contratadas no item selecionado (valor preenchido em coberturas_dinamicas e
  // diferente de "não"/"sem cobertura") — pedido do usuário: nao adianta a seguradora oferecer
  // Vidros se o segurado nao contratou Vidros nesse item especifico.
  const valorIndicaNaoContratado = (v) => {
    const n = (v ?? '').toString().trim().toLowerCase()
    return !n || ['não', 'nao', 'não contratado', 'nao contratado', 'sem cobertura', 'n/a'].includes(n)
  }
  const tiposAssistenciaDisponiveis = itemSelecionadoObj
    ? coberturasAcessoriasSeguradora
      .filter(c => !valorIndicaNaoContratado(itemSelecionadoObj.coberturas_dinamicas?.[c.campo]))
      .map(c => c.campo)
    : []

  const apolicesFiltradas = (() => {
    const termo = apoliceBusca.trim().toLowerCase()
    if (!termo || apoliceTravada) return []
    return apolicesTodas
      .filter(a => a.status === 'emitido')
      .filter(a => (a.cliente_nome || '').toLowerCase().includes(termo) || (a.numero_apolice || '').includes(termo) || (a.emissao_numero_apolice || '').includes(termo))
      .slice(0, 8)
  })()

  const selecionarApolice = (a) => {
    setApoliceSelecionada(a)
    setApoliceBusca(`${a.cliente_nome} — ${a.numero_apolice || a.emissao_numero_apolice || 'sem número'}`)
    setForm(f => ({ ...f, apolice_id: a.id, cliente_id: a.cliente_id, apolice_item_id: '', tipo_assistencia: '' }))
    setMostrarSugestoesApolice(false)
  }
  const navApolice = useNavegacaoLista(apolicesFiltradas.length, (i) => selecionarApolice(apolicesFiltradas[i]))

  const setField = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }))

  const salvar = async () => {
    if (!form.apolice_id) { avisar('Selecione a apólice da assistência.'); return null }
    setSalvando(true)
    try {
      const payload = { ...form, valor_franquia: form.valor_franquia, valor_outros: form.valor_outros }
      const { data } = assistenciaId ? await api.put(`/assistencias/${assistenciaId}`, payload) : await api.post('/assistencias', payload)
      setAssistenciaId(data.id)
      onSaved?.()
      setModoEdicao(false)
      return data.id
    } catch (err) {
      avisar('Erro ao salvar assistência: ' + (err.response?.data?.erro || err.message))
      return null
    } finally {
      setSalvando(false)
    }
  }

  const excluir = async () => {
    if (!(await confirmar('Excluir esta assistência? Essa ação não pode ser desfeita.'))) return
    setPedirSenhaMasterExcluir(true)
  }
  const confirmarExclusaoComSenha = async (senha) => {
    await api.delete(`/assistencias/${assistenciaId}`, { data: { senha_master: senha } })
    setPedirSenhaMasterExcluir(false)
    onSaved?.()
    onClose()
  }

  if (carregando) return <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Carregando...</div>

  const st = statusInfo(form.status)

  const resumoApoliceCard = apoliceSelecionada && (
    <div className="card" style={{ border: '2px solid rgba(var(--primary-rgb),0.15)' }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 10 }}>
        Resumo da Apólice
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, fontSize: 13 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
          <CampoResumo label="Segurado" valor={apoliceSelecionada.cliente_nome} />
          <CampoResumo label="CPF/CNPJ" valor={clienteSelecionado?.cpf_cnpj} />
          <CampoResumo label="Nº Apólice" valor={apoliceSelecionada.numero_apolice || apoliceSelecionada.emissao_numero_apolice} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
          <CampoResumo label="Item" valor={itemSelecionadoObj ? (itemSelecionadoObj.descricao_item || itemSelecionadoObj.item_modelo || `Item ${itemSelecionadoObj.numero_item}`) : null} />
          <CampoResumo label="Placa" valor={itemSelecionadoObj?.item_placa} />
          <CampoResumo label="Chassi" valor={itemSelecionadoObj?.item_chassi} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div>
            <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>Telefone{clienteSelecionado?.telefones?.length > 1 ? 's' : ''}</div>
            {clienteSelecionado?.telefones?.length ? clienteSelecionado.telefones.map((t, i) => (
              <div key={i} style={{ color: '#333' }}>{t.numero}{t.nome ? ` (${t.nome})` : ''}</div>
            )) : <div style={{ color: '#333' }}>—</div>}
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>E-mail{clienteSelecionado?.emails?.length > 1 ? 's' : ''}</div>
            {clienteSelecionado?.emails?.length ? clienteSelecionado.emails.map((e, i) => (
              <div key={i} style={{ color: '#333', wordBreak: 'break-all' }}>{e}</div>
            )) : <div style={{ color: '#333' }}>—</div>}
          </div>
        </div>
      </div>
      {anexoApolicePdf && (
        <button type="button" className="btn btn-secondary" style={{ width: '100%', marginTop: 12 }} onClick={abrirPdfApolice}>
          📄 Abrir PDF da Apólice
        </button>
      )}
    </div>
  )

  const historicoCard = (
    <div className="card">
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 10 }}>
        Histórico de Atendimento
      </div>
      {assistenciaId
        ? <HistoricoAssistencia assistenciaId={assistenciaId} />
        : <div style={{ padding: 14, textAlign: 'center', color: '#aaa', background: '#f8f9fa', borderRadius: 8, fontSize: 12 }}>Disponível depois de salvar a assistência.</div>}
    </div>
  )

  return (
    <div style={{ padding: '24px 24px 40px' }}>
      <div style={{ marginBottom: 14 }}>
        <button type="button" onClick={onVoltar || onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontSize: 13, fontWeight: 600, padding: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
          ‹ Voltar para {voltarLabel}
        </button>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
          <h2 style={{ margin: '8px 0 0', fontSize: 22, fontWeight: 700 }}>{assistenciaId ? `Assistência ${form.numero_assistencia ? `nº ${form.numero_assistencia}` : ''}` : 'Nova Assistência'}</h2>
          {assistenciaId && !modoEdicao && (
            <div style={{ display: 'flex', gap: 10, marginTop: 8, flexShrink: 0 }}>
              <button type="button" className="btn btn-danger btn-icon" title="Excluir" onClick={excluir}><IconExcluir size={16} /></button>
              <button type="button" className="btn btn-primary btn-icon" title="Editar" onClick={() => setModoEdicao(true)}><IconEditar size={16} /></button>
            </div>
          )}
        </div>
      </div>

      {apoliceSelecionada && (
        <div className="card" style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 22, fontWeight: 700, color: 'var(--primary)', letterSpacing: '0.01em' }}>{apoliceSelecionada.cliente_nome}</span>
          <span className={`badge ${st.cls}`}>{st.label}</span>
        </div>
      )}

      {modoEdicao && (
      <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 20, minWidth: 0 }}>

        {/* ===== CARD DADOS ===== */}
        <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, paddingBottom: 6, borderBottom: '2px solid var(--primary-light)' }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Dados</div>
            <span className={`badge ${st.cls}`}>{st.label}</span>
          </div>

          <div className="form-group">
            <label className="form-label">Apólice *</label>
            <div style={{ position: 'relative' }}>
              <input className="form-input" value={apoliceBusca}
                onChange={e => { setApoliceBusca(e.target.value); setMostrarSugestoesApolice(true); if (!e.target.value) { setApoliceSelecionada(null); setField('apolice_id', ''); setField('cliente_id', '') }; navApolice.reset() }}
                onFocus={() => setMostrarSugestoesApolice(true)}
                onBlur={() => setTimeout(() => setMostrarSugestoesApolice(false), 150)}
                onKeyDown={navApolice.onKeyDown}
                placeholder="Buscar por nome do cliente ou nº da apólice..."
                disabled={apoliceTravada}
                style={{ opacity: apoliceTravada ? 0.7 : 1 }}
                autoComplete="off" />
              {mostrarSugestoesApolice && apolicesFiltradas.length > 0 && (
                <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 20, background: '#fff', border: '1px solid #D9DDE3', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', maxHeight: 220, overflowY: 'auto' }}>
                  {apolicesFiltradas.map((a, i) => (
                    <button key={a.id} type="button" onMouseDown={() => selecionarApolice(a)}
                      onMouseEnter={() => navApolice.setIndice(i)}
                      style={{ width: '100%', textAlign: 'left', border: 'none', background: i === navApolice.indice ? 'rgba(var(--primary-rgb),0.08)' : '#fff', padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #F1F3F5' }}>
                      <div style={{ fontSize: 13, color: '#1A1A2E', fontWeight: 600 }}>{a.cliente_nome}</div>
                      <div style={{ fontSize: 11, color: '#7A7F87', marginTop: 2 }}>{a.seguradora} · {a.ramo} · Nº {a.numero_apolice || a.emissao_numero_apolice}</div>
                    </button>
                  ))}
                </div>
              )}
            </div>
            {apoliceSelecionada && <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{apoliceSelecionada.seguradora} · {apoliceSelecionada.ramo}</div>}
          </div>

          <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
            <div className="form-group">
              <label className="form-label">Nº da Assistência</label>
              <input className="form-input" value={form.numero_assistencia} onChange={e => setField('numero_assistencia', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Item Segurado</label>
              <select className="form-select" value={form.apolice_item_id} onChange={e => {
                // Nao auto-preenche a Franquia a partir do item: a franquia da Assistencia e um
                // valor proprio do servico, diferente da franquia do casco do veiculo/residencia.
                // Tipo de Assistência depende das coberturas contratadas nesse item especifico —
                // zera pra nao deixar um valor que nao e mais valido pro item novo selecionado.
                setForm(f => ({ ...f, apolice_item_id: e.target.value, tipo_assistencia: '' }))
              }} disabled={itensApolice.length === 0}>
                <option value="">{itensApolice.length === 0 ? 'Sem itens nesta apólice' : 'Selecione...'}</option>
                {itensApolice.map(i => <option key={i.id} value={i.id}>{i.item_placa || i.descricao_item || `Item ${i.numero_item}`}{i.item_modelo ? ` — ${i.item_modelo}` : ''}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Status</label>
              <select className="form-select" value={form.status} onChange={e => setField('status', e.target.value)}>
                {statusOptions.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Observações</label>
            <textarea className="form-input" rows={2} style={{ resize: 'vertical' }} value={form.observacoes} onChange={e => setField('observacoes', e.target.value)} />
          </div>
        </div>

        {/* ===== CARD OCORRÊNCIA ===== */}
        <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
          {sec('Ocorrência')}
          <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
            <div className="form-group">
              <label className="form-label">Data da Abertura da Assistência</label>
              <input className="form-input" type="date" value={form.data_abertura} onChange={e => setField('data_abertura', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Tipo de Assistência</label>
              <select className="form-select" value={form.tipo_assistencia} onChange={e => setField('tipo_assistencia', e.target.value)} disabled={tiposAssistenciaDisponiveis.length === 0}>
                <option value="">{tiposAssistenciaDisponiveis.length === 0 ? 'Nenhuma disponível' : 'Selecione...'}</option>
                {tiposAssistenciaDisponiveis.map(t => <option key={t}>{t}</option>)}
              </select>
              {!itemSelecionadoObj && apoliceSelecionada && (
                <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>
                  Selecione o Item Segurado acima pra ver as assistências contratadas nele.
                </div>
              )}
              {itemSelecionadoObj && coberturasAcessoriasSeguradora.length === 0 && (
                <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>
                  Nenhuma cobertura de assistência cadastrada para {apoliceSelecionada.seguradora} · {apoliceSelecionada.ramo}. Marque a cobertura em Cadastro &gt; Coberturas.
                </div>
              )}
              {itemSelecionadoObj && coberturasAcessoriasSeguradora.length > 0 && tiposAssistenciaDisponiveis.length === 0 && (
                <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>
                  Este item não tem nenhuma assistência contratada (confira as coberturas em Apólices &gt; Itens).
                </div>
              )}
            </div>
            <div className="form-group">
              <label className="form-label">Detalhe</label>
              <input className="form-input" value={form.detalhe} onChange={e => setField('detalhe', e.target.value)} placeholder="Ex.: para-brisa dianteiro, torneira da cozinha..." />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Descrição do Ocorrido</label>
            <textarea className="form-input" rows={3} style={{ resize: 'vertical' }} value={form.descricao} onChange={e => setField('descricao', e.target.value)} />
          </div>
        </div>

        {/* ===== CARD VALORES ===== */}
        <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
          {sec('Valores')}
          <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
            <div className="form-group">
              <label className="form-label">Valor da Franquia</label>
              <input className="form-input" value={form.valor_franquia} onChange={e => setField('valor_franquia', e.target.value)} placeholder="R$ 0,00" />
            </div>
            <div className="form-group">
              <label className="form-label">Outros Valores (se houver)</label>
              <input className="form-input" value={form.valor_outros} onChange={e => setField('valor_outros', e.target.value)} placeholder="R$ 0,00" />
            </div>
          </div>
        </div>

        {/* ===== CARD ANEXOS ===== */}
        <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
          {sec('Anexos')}
          {assistenciaId
            ? <AnexosAssistencia id={assistenciaId} />
            : <div style={{ padding: 24, textAlign: 'center', color: '#aaa', background: '#f8f9fa', borderRadius: 8, fontSize: 13 }}>Salve os dados da assistência primeiro.</div>}
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          {assistenciaId && <button type="button" className="btn btn-danger btn-icon" title="Excluir" onClick={excluir}><IconExcluir size={16} /></button>}
          <button type="button" className="btn btn-secondary" onClick={cancelarEdicao}>{assistenciaId ? 'Cancelar' : 'Fechar'}</button>
          <button type="button" className="btn btn-primary" onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>

      {/* ===== BARRA LATERAL DIREITA ===== */}
      <div style={{ width: 450, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 20 }}>
        {resumoApoliceCard}
        {historicoCard}
      </div>
      </div>
      )}

      {/* ===== VISUALIZACAO (assistência já salva, fora do modo de edição) ===== */}
      {assistenciaId && !modoEdicao && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, alignItems: 'start' }}>
          {historicoCard}

          <div style={{ display: 'flex', flexDirection: 'column', gap: 20, minWidth: 0 }}>
            {resumoApoliceCard}

            {/* ===== CARD RESUMO DA ASSISTÊNCIA ===== */}
            <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
              {sec('Resumo da Assistência')}

              {subLabelSublinhado('Dados')}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, fontSize: 13 }}>
                <CampoResumo label="Nº da Assistência" valor={form.numero_assistencia} />
                <CampoResumo label="Item Segurado" valor={itemSelecionadoObj ? (itemSelecionadoObj.item_placa || itemSelecionadoObj.descricao_item || `Item ${itemSelecionadoObj.numero_item}`) : null} />
              </div>
              {form.observacoes && <div style={{ marginTop: 10 }}><CampoResumo label="Observações" valor={form.observacoes} /></div>}

              {subLabelSublinhado('Ocorrência')}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, fontSize: 13 }}>
                <CampoResumo label="Data da Abertura" valor={fmtData(form.data_abertura)} />
                <CampoResumo label="Tipo de Assistência" valor={form.tipo_assistencia} />
                <CampoResumo label="Detalhe" valor={form.detalhe} />
              </div>
              <div style={{ marginTop: 10 }}>
                <CampoResumo label="Descrição do Ocorrido" valor={form.descricao} />
              </div>

              {subLabelSublinhado('Valores')}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, fontSize: 13 }}>
                <CampoResumo label="Valor da Franquia" valor={form.valor_franquia} />
                <CampoResumo label="Outros Valores" valor={form.valor_outros} />
              </div>
            </div>

            {/* ===== CARD ANEXOS ===== */}
            <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
              {sec('Anexos')}
              <AnexosAssistencia id={assistenciaId} />
            </div>
          </div>
        </div>
      )}
      {pedirSenhaMasterExcluir && (
        <SenhaMasterModal
          titulo="Excluir assistência?"
          mensagem="Confirme com a Senha Master para excluir esta assistência definitivamente."
          onCancelar={() => setPedirSenhaMasterExcluir(false)}
          onConfirmar={confirmarExclusaoComSenha}
        />
      )}
    </div>
  )
}

// ===== Página principal =====
const normalizarAssistencia = (s) => ({
  id: s.id, numero: s.numero_assistencia,
  nome: s.cliente_nome,
  apolice: s.numero_apolice || s.emissao_numero_apolice,
  seguradora: s.seguradora, tipo: s.tipo_assistencia || '',
  abertura: s.data_abertura, status: s.status,
})

const colunasAssistencias = [
  { key: 'numero',    label: 'Nº Assistência', get: r => r.numero || '' },
  { key: 'nome',      label: 'Nome',           get: r => r.nome || '' },
  { key: 'apolice',   label: 'Apólice',        get: r => r.apolice || '' },
  { key: 'seguradora', label: 'Seguradora',    get: r => r.seguradora || '' },
  { key: 'tipo',      label: 'Tipo',           get: r => r.tipo || '' },
  { key: 'abertura',  label: 'Abertura',       get: r => r.abertura || '', date: true },
  { key: 'status',    label: 'Status',         get: r => statusInfo(r.status).label },
]

export default function Assistencias() {
  const navigate = useNavigate()
  const [assistencias, setAssistencias] = useState([])
  const [carregando, setCarregando] = useState(true)
  const [busca, setBusca] = useState('')
  // Mais de um status ao mesmo tempo (nenhum marcado = todos) — pedido do usuario, 26/10
  // Filtro abre/fecha pelo botao (igual Apolices/Renovacoes); fechar nao limpa. Salvo em localStorage.
  const [filtroStatus, setFiltroStatus] = useState(() => { try { const f = JSON.parse(localStorage.getItem('assistencias.filtros')); return Array.isArray(f?.status) ? f.status : [] } catch { return [] } })
  const [filtroAberto, setFiltroAberto] = useState(() => { try { return !!JSON.parse(localStorage.getItem('assistencias.filtros'))?.aberto } catch { return false } })
  useEffect(() => {
    try { localStorage.setItem('assistencias.filtros', JSON.stringify({ status: filtroStatus, aberto: filtroAberto })) } catch { /* sem localStorage: so nao persiste */ }
  }, [filtroStatus, filtroAberto])
  const [sortCol, setSortCol] = useState('abertura')
  const [sortDir, setSortDir] = useState('desc')
  const [modalAberto, setModalAberto] = useState(false)
  const [assistenciaEditId, setAssistenciaEditId] = useState(null)
  const [apoliceParaNovo, setApoliceParaNovo] = useState(null)
  const [voltarPara, setVoltarPara] = useState(null)

  const toggleSort = (key) => {
    if (sortCol === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc')
    else { setSortCol(key); setSortDir('asc') }
  }

  const carregar = () => {
    setCarregando(true)
    api.get('/assistencias').then(r => setAssistencias(Array.isArray(r.data) ? r.data : [])).catch(() => setAssistencias([])).finally(() => setCarregando(false))
  }
  useEffect(() => { carregar() }, [])

  // Vindo do botão Ações > Assistências na tela de Apólices: abre direto o form de Nova
  // Assistência com a apólice já travada (mesmo padrão de Sinistros.jsx).
  useEffect(() => {
    const apoliceJson = sessionStorage.getItem('assistenciaNovaApolice')
    if (apoliceJson) {
      sessionStorage.removeItem('assistenciaNovaApolice')
      try {
        setApoliceParaNovo(JSON.parse(apoliceJson))
        setAssistenciaEditId(null)
        setModalAberto(true)
      } catch { /* ignora json invalido */ }
    }
  }, [])

  // Vindo do botão amarelo de Assistência na tela de Renovações: abre direto a assistência (a mais
  // recente daquela apólice) em vez de so filtrar a lista, e guarda pra onde "‹ Voltar" deve ir.
  useEffect(() => {
    const abrirId = sessionStorage.getItem('assistenciaAbrirId')
    if (abrirId) {
      sessionStorage.removeItem('assistenciaAbrirId')
      setApoliceParaNovo(null)
      setAssistenciaEditId(Number(abrirId))
      setModalAberto(true)
    }
    const voltar = sessionStorage.getItem('assistenciaVoltarPara')
    if (voltar) { sessionStorage.removeItem('assistenciaVoltarPara'); setVoltarPara(voltar) }
  }, [])

  const abrirNovo = () => { setApoliceParaNovo(null); setAssistenciaEditId(null); setModalAberto(true) }
  const abrirVer = (r) => { setApoliceParaNovo(null); setAssistenciaEditId(r.id); setModalAberto(true) }
  const fecharModal = () => { setModalAberto(false); setAssistenciaEditId(null); setApoliceParaNovo(null) }

  const registros = assistencias.map(normalizarAssistencia)

  const filtrados = registros.filter(r => {
    if (filtroStatus.length && !filtroStatus.includes(r.status)) return false
    if (busca.trim()) {
      const termo = busca.trim().toLowerCase()
      const alvo = `${r.nome} ${r.numero || ''} ${r.apolice || ''}`.toLowerCase()
      if (!alvo.includes(termo)) return false
    }
    return true
  })
  const ordenados = sortRows(filtrados, colunasAssistencias, sortCol, sortDir)
  const paginacao = usePaginacao(ordenados)

  return (
    <>
      {!modalAberto && (<>
      <div style={{ padding: '32px 24px 0' }}>
        <h2 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>Assistências</h2>
        <div style={{ fontSize: 13, color: '#888', marginTop: 4, marginBottom: 20 }}>Acompanhe as assistências acionadas pelos segurados.</div>
        <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'center' }}>
          <input className="form-input" placeholder="Buscar por segurado, nº da assistência ou da apólice..." value={busca} onChange={e => setBusca(e.target.value)}
            style={{ maxWidth: 420, width: '100%', border: '2px solid rgba(var(--primary-rgb),0.15)', borderRadius: 10 }} />
          <button type="button" className="btn btn-secondary" style={{ flexShrink: 0, whiteSpace: 'nowrap' }} onClick={() => setFiltroAberto(v => !v)}>
            {filtroAberto ? 'Fechar filtros' : 'Abrir filtros'}{filtroStatus.length > 0 && <span style={{ color: 'var(--primary)', marginLeft: 6 }}>●</span>}
          </button>
          <div style={{ flex: 1 }} />
          <button className="btn btn-primary" onClick={abrirNovo}>+ Nova Assistência</button>
        </div>
        {filtroAberto && (
          <div className="card" style={{ marginBottom: 16, padding: 16 }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 12, alignItems: 'end' }}>
              <SelecaoMultipla label="Status" opcoes={statusOptions.map(s => ({ valor: s.value, label: s.label }))} valores={filtroStatus} onChange={setFiltroStatus} />
              <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <button type="button" className="btn btn-secondary" disabled={!filtroStatus.length} onClick={() => setFiltroStatus([])}>Limpar filtros</button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="page-content" style={{ paddingTop: 0 }}>
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12, fontSize: 12, color: '#888' }}>
            {filtrados.length} {filtrados.length === 1 ? 'registro' : 'registros'}
          </div>
          <div className="table-wrap">
            <table className="table-borda-destaque table-compacta">
              <thead>
                <tr>
                  {colunasAssistencias.map(c => (
                    <SortableTh key={c.key} colKey={c.key} sortCol={sortCol} sortDir={sortDir} onSort={toggleSort}>{c.label}</SortableTh>
                  ))}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {paginacao.itensPagina.map((r, i) => {
                  const st = statusInfo(r.status)
                  return (
                    <tr key={`${r.id}-${i}`}>
                      <td style={{ textAlign: 'center' }}>{r.numero || '—'}</td>
                      <td style={{ fontWeight: 500 }}>{r.nome}</td>
                      <td style={{ textAlign: 'center' }}>{r.apolice || '—'}</td>
                      <td style={{ textAlign: 'center' }}>{r.seguradora || '—'}</td>
                      <td style={{ textAlign: 'center' }}>{r.tipo || '—'}</td>
                      <td style={{ textAlign: 'center' }}>{fmtData(r.abertura)}</td>
                      <td style={{ textAlign: 'center' }}><span className={`badge ${st.cls}`}>{st.label}</span></td>
                      <td style={{ textAlign: 'center' }}><button type="button" className="btn btn-secondary btn-sm btn-icon" title="Ver" style={{ color: 'var(--primary)' }} onClick={() => abrirVer(r)}><IconVisualizar size={14} /></button></td>
                    </tr>
                  )
                })}
                {!carregando && ordenados.length === 0 && (
                  <tr><td colSpan={colunasAssistencias.length + 1} style={{ textAlign: 'center', color: '#aaa', padding: 32 }}>Nenhuma assistência encontrada</td></tr>
                )}
              </tbody>
            </table>
          </div>
          <Paginacao {...paginacao} rotulo="assistência" />
        </div>
      </div>
      </>)}

      {modalAberto && (
        <AssistenciaModal
          assistenciaId={assistenciaEditId}
          apoliceInicial={apoliceParaNovo}
          onClose={fecharModal}
          onSaved={carregar}
          voltarLabel={voltarPara ? 'Renovações' : 'Assistências'}
          onVoltar={voltarPara ? () => navigate(voltarPara) : null}
        />
      )}
    </>
  )
}
